import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";
import URI from "URI/URI";
import History from "history";


"use strict";
var history_id = Math.ceil(Math.random(10000));
//var History = window.history;

function _check_redirect(page, state, hash) {
    if (hash === "" || hash === "/") {
        console.error("forcing history to home page");
        var data = {
            link: ko.unwrap(page.userprofile.home_page) || "home",
            title: _("page_title_home", "Home")
        };
        state = uly.history.get_temporary_state(data);
        uly.publish("history.replacestate", state);
    }
    return state;
}

function handle_state_change(nav) {
    var state = History.getState();
    var sid = state._sid || (state.data && state.data._sid);
    console.error("State change: ", state, sid, nav._expected_states, nav._expected_states.indexOf(sid), "internal:", state.internal);
    if (nav._expected_states.indexOf(sid) >= 0) {
        nav._expected_states.splice(nav._expected_states.indexOf(sid), 1);
        return;
    }
    if (!nav._changing) {
        uly.page.reload(state);
    }
}

class Navigation {
    constructor() {
        var self = this;
        this._expected_states = [];
        this._changing = false;
        History.Adapter.bind(window, "statechange", function() { handle_state_change(self) });

        window.onpopstate = function(event) {
            var state = event.state;
            console.log("Event: ", event.state);
            //uly.page.reload(state);
        }

        uly.subscribe("history.pushstate", function (topic, state) {
            self.push_state(state, state.hash);
        });

        uly.subscribe("history.replacestate", function (topic, state) {
            self.replace_state(state, state.hash);
        });
    }

    push_state(data, path) {
        //save current state
        var state = this.get_state();
        uly.publish("page.save_state", state, true);
        this._changing = true;
        try {
            this.replace_state(state.data, state.url);
        } finally {
            this._changing = false;
        }
        History.pushState(data, null, path);
    }

    replace_state(data, path) {
        if (!path && $.type(data) == "string") {
            path = data;
            data = {};
        }
        data = data || {};
        var new_id = history_id++;
        $.extend(data, {
            "_sid": new_id
        });
        this._expected_states.push(new_id);
        History.replaceState(data, document.title, path);
    }

    get_state () {
        return History.getState();
    }

    get_parsed_state() {
        var state = this.get_state();
        var parsed_state = {
            hash: state.hash,
            hashed_url: state.hashedUrl,
            fragment: state.hash.substring(0, state.hash.indexOf("?") >= 0 ? state.hash.indexOf("?") : undefined),
            query_string: state.hash.substring(state.hash.indexOf("?") + 1),
            query_data: new URI(state.hashedUrl).query(true),
            data: state.data
        };
        return parsed_state;
    }

    previous() {
        return History.getState();
    }

    go(state) {
        return History.go(state);
    }

    get_link(data) {
        var link = null;
        if (!data)
            return null;

        if (uly.utils.is_type(data,"String")) {
            link = data;
        } else if (uly.utils.is_type(data, "Object") || uly.utils.is_type(data,"Location")) {
            if (!link)
                link = data["link"];
            if (!link)
                link = data["href"];
            if (!link)
                link = data["url"];
        }
        if (!link)
            return null;

        var clink = link.toLowerCase();
        if (clink.indexOf(uly.api.root.toLowerCase()) === 0) {
            link = link.slice(uly.api.root.length);
            clink = link.toLowerCase();
        }

        if (clink.indexOf(uly.root.toLowerCase()) === 0) {
            link = link.slice(uly.root.length);
            clink = link.toLowerCase();
        }

        if (clink.indexOf(uly.url_root.toLowerCase()) === 0) {
            link = link.slice(uly.url_root.length);
        }

        if (link.indexOf("data/") == 0)
            link = link.slice(5);
        else if (link.indexOf("/data/") == 0)
            link = link.slice(6);
        if (link.indexOf("/") == 0)
            link = link.slice(1);
        if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0 || link.indexOf("ftp://") == 0 || link.indexOf("mailto:") == 0 || link.indexOf("tel:") == 0 || link.indexOf("callto:") == 0) {
            return link;
        }
        return uly.url_root + link;
    }

    get_temporary_state(data) {
        if (uly.utils.is_type(data, "String")) data = {
            href: data,
            title: ""
        };

        data = $.extend({}, data, {
            suid: new Date().getTime()
        });
        var a = History.normalizeState({
            "data": data,
            "title": data["title"] || "Ulysses",
            "url": this.get_link(data)
        });
        return a;
    }

}

export default Navigation;
